import { Box } from "@mui/material";
import { DesktopDateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { useState } from "react";

import Svg from "../../../../../../ui library/components/svgs/standard/svg";
import HNSColors from "../../../../../../ui library/HNSColors";
import QuestionTitle from "../../../components/QuestionTitle";
import sharedStyles from "../styles/formStyles";

export function ActionItemDateAnswer({ name, label, value = "", onChange, placeholder }) {
  const [isFocused, setIsFocused] = useState(false);

  const handleChange = (newDate) => onChange(name, newDate?.toISOString());

  return (
    <Box mb={2}>
      <QuestionTitle label={label} sx={sharedStyles.label(isFocused)} />
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DesktopDateTimePicker
          className="w-full text-center"
          format="MM/dd/yyyy - hh:mm a"
          id="field_followup_date"
          name="dueDate"
          value={value ? new Date(value) : null}
          onChange={handleChange}
          onOpen={() => setIsFocused(true)}
          onClose={() => setIsFocused(false)}
          slots={{
            openPickerIcon: CalendarIcon,
          }}
          slotProps={{
            textField: {
              onFocus: () => setIsFocused(true),
              onBlur: () => setIsFocused(false),
              sx: sharedStyles.dateTimePicker.textField,
              placeholder,
            },
            openPickerButton: {
              disableRipple: true,
              sx: sharedStyles.dateTimePicker.openPickerButton,
            },
          }}
        />
      </LocalizationProvider>
    </Box>
  );
}

const CalendarIcon = (props) => (
  <Svg {...props} name="his-calendar" color={HNSColors.primary[500]} sx={{ ...props.sx }} />
);
